import { render, staticRenderFns } from "./viewModal.vue?vue&type=template&id=36090e0c&scoped=true&"
import script from "./viewModal.vue?vue&type=script&lang=js&"
export * from "./viewModal.vue?vue&type=script&lang=js&"
import style0 from "./viewModal.vue?vue&type=style&index=0&id=36090e0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36090e0c",
  null
  
)

export default component.exports